import { connect } from 'react-redux';
import { getShouldShowFirstTimeExperience } from '../../redux/selectors/firstTime';
import App from './App';
import {
  fetchAreas,
  fetchTeamMembers,
  fetchTeamMemberUsers,
  setEnforceContributors
} from '../../redux/actions/serverApi.actions';
import { getAccountId, getIsSite, getLocale } from '../../redux/selectors/config';

const mapStateToProps = state => {
  return {
    shouldShowFirstTimeExperience: getShouldShowFirstTimeExperience(state),
    accountId: getAccountId(state),
    locale: getLocale(state),
    isSiteLevel: getIsSite(state),
  };
};

export const connector = connect(
  mapStateToProps,
  { fetchTeamMembers, fetchAreas, fetchTeamMemberUsers, setEnforceContributors },
);
export default connector(App);
